var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAuthenticator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 130C104.137 130 131 103.137 131 70C131 36.8629 104.137 10 71 10C37.8629 10 11 36.8629 11 70C11 103.137 37.8629 130 71 130Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108.164C49.9306 108.164 32.8356 91.0694 32.8356 70C32.8356 48.9306 49.9306 31.8356 71 31.8356C81.5347 31.8356 91.0638 36.0974 98.0072 43.0407L113.426 27.6217C102.556 16.7039 87.5682 10 71 10C37.8635 10 11 36.8635 11 70C11 103.136 37.8635 130 71 130C87.5682 130 102.556 123.296 113.426 112.426L98.0072 97.0072C91.0638 103.903 81.5347 108.164 71 108.164Z",
    fill: "#6d7177"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.164 70.0007H90.058C90.058 59.466 81.4866 50.8945 70.9518 50.8945C60.4171 50.8945 51.8457 59.466 51.8457 70.0007C51.8457 75.1244 53.8569 79.7692 57.1609 83.217L80.8162 106.872C97.1929 102.515 109.164 87.6703 109.164 70.0007Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.999 70H109.163C109.163 87.6696 97.1442 102.514 80.8633 106.872L97.7188 123.727C117.447 113.911 130.999 93.5595 130.999 70Z",
    fill: "#616161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71 129.329C37.9593 129.329 11.1915 102.657 11 69.6641C11 69.7598 11 69.9035 11 69.9993C11 103.136 37.8635 129.999 71 129.999C104.136 129.999 131 103.136 131 69.9993C131 69.9035 131 69.7598 131 69.6641C130.808 102.657 104.041 129.329 71 129.329Z",
    fill: "#212121",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8633 106.872L81.39 107.398C97.4315 102.849 109.163 88.1484 109.163 70.6704V70C109.163 87.6696 97.1442 102.514 80.8633 106.872Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.109 64.5664H70.9784C67.9617 64.5664 65.5195 67.0085 65.5195 70.0253C65.5195 73.0421 67.9617 75.4842 70.9784 75.4842H120.109C123.125 75.4842 125.567 73.0421 125.567 70.0253C125.567 67.0085 123.125 64.5664 120.109 64.5664Z",
    fill: "#6d7177"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M120.109 64.5664H70.9784C67.9617 64.5664 65.5195 67.0085 65.5195 70.0253C65.5195 73.0421 67.9617 75.4842 70.9784 75.4842H120.109C123.125 75.4842 125.567 73.0421 125.567 70.0253C125.567 67.0085 123.125 64.5664 120.109 64.5664Z",
    fill: "#BDBDBD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9169 74.0702C24.1648 74.0702 25.9871 72.2478 25.9871 69.9999C25.9871 67.752 24.1648 65.9297 21.9169 65.9297C19.669 65.9297 17.8467 67.752 17.8467 69.9999C17.8467 72.2478 19.669 74.0702 21.9169 74.0702Z",
    fill: "#BDBDBD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9999 24.9881C73.2478 24.9881 75.0702 23.1658 75.0702 20.9179C75.0702 18.67 73.2478 16.8477 70.9999 16.8477C68.752 16.8477 66.9297 18.67 66.9297 20.9179C66.9297 23.1658 68.752 24.9881 70.9999 24.9881Z",
    fill: "#BDBDBD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9999 123.152C73.2478 123.152 75.0702 121.33 75.0702 119.082C75.0702 116.834 73.2478 115.012 70.9999 115.012C68.752 115.012 66.9297 116.834 66.9297 119.082C66.9297 121.33 68.752 123.152 70.9999 123.152Z",
    fill: "#BDBDBD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2353 39.3553C38.4832 39.3553 40.3055 37.533 40.3055 35.2851C40.3055 33.0371 38.4832 31.2148 36.2353 31.2148C33.9873 31.2148 32.165 33.0371 32.165 35.2851C32.165 37.533 33.9873 39.3553 36.2353 39.3553Z",
    fill: "#BDBDBD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2865 104.951C40.3884 102.705 38.6504 100.802 36.4048 100.701C34.1591 100.599 32.256 102.337 32.1542 104.582C32.0523 106.828 33.7902 108.731 36.0359 108.833C38.2816 108.935 40.1846 107.197 40.2865 104.951Z",
    fill: "#BDBDBD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.764 108.836C108.012 108.836 109.834 107.013 109.834 104.766C109.834 102.518 108.012 100.695 105.764 100.695C103.516 100.695 101.693 102.518 101.693 104.766C101.693 107.013 103.516 108.836 105.764 108.836Z",
    fill: "#757575"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9999 65.2134H120.082C122.955 65.2134 125.349 67.464 125.493 70.3371C125.493 70.2413 125.493 70.0976 125.493 70.0019C125.493 66.9851 123.051 64.543 120.034 64.543H70.9999C67.9832 64.543 65.541 66.9851 65.541 70.0019C65.541 70.0976 65.541 70.2413 65.541 70.3371C65.7326 67.5118 68.0789 65.2134 70.9999 65.2134Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M125.542 70.3359C125.35 73.1612 123.004 75.4596 120.131 75.4596H71.0009C68.1278 75.4596 65.7335 73.209 65.5898 70.3359C65.5898 70.4317 65.5898 70.5754 65.5898 70.6711C65.5898 73.6879 68.032 76.13 71.0487 76.13H120.131C123.148 76.13 125.59 73.6879 125.59 70.6711C125.542 70.5754 125.542 70.4796 125.542 70.3359Z",
    fill: "#212121",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0003 32.5054C81.5351 32.5054 91.0642 36.7671 98.0075 43.7105L113.762 27.9563C113.666 27.8605 113.522 27.7169 113.427 27.6211L98.0075 43.0401C91.1121 36.1446 81.5351 31.835 71.0003 31.835C49.9309 31.835 32.8359 48.93 32.8359 69.9994C32.8359 70.0952 32.8359 70.2388 32.8359 70.3346C33.0275 49.4088 50.0267 32.5054 71.0003 32.5054Z",
    fill: "#212121",
    fillOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71 130C104.137 130 131 103.137 131 70C131 36.8629 104.137 10 71 10C37.8629 10 11 36.8629 11 70C11 103.137 37.8629 130 71 130Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5863 27.5526) scale(119.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuthenticator);
export default __webpack_public_path__ + "static/media/google_authenticator.e9e49be8123f3c5cb6485dbb3c785ca3.svg";
export { ForwardRef as ReactComponent };